import React, { useMemo } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from '../../../../../_metronic/_partials/controls';
import { injectIntl } from 'react-intl';
import BoxesFilter from './boxes-filter/BoxesFilter';
import BoxesTable from './boxes-table/BoxesTable';
import { useBoxesUIContext } from './BoxesUIContext';

const BoxesCard = (props) => {
  const { intl } = props;
  const title = intl.formatMessage({ id: 'BOX.TITLE.LIST' });
  const boxesUIContext = useBoxesUIContext();
  const boxesUIProps = useMemo(() => {
    return {
      queryParams: boxesUIContext.queryParams,
      setQueryParams: boxesUIContext.setQueryParams,
      openViewBoxDialog: boxesUIContext.openViewBoxDialog,
    };
  }, [boxesUIContext]);

  return (
    <Card id='boxesCard'>
      <CardHeader title={title}></CardHeader>
      <CardBody>
        <BoxesFilter props />
        <BoxesTable props />
      </CardBody>
    </Card>
  );
};

export default injectIntl(BoxesCard);
